// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2uoJ9","list":"PatternAutocomplete_list__2LzNZ"};